import { ListRow } from "../../../components/ui/list/ListRow";
import { Badge } from "@/components/ui/Badge";

import {
  TableCell,
} from "@/components/shadcn/table";

import { AppointmentActionDropdown } from "../../appointment/actions";

export default function AppointmentRow(props) {

  const row = props.item;

  const onHandle = () => {};

  return (
    <ListRow items={props.items} key={row.key} action={false} move={false} onToggle={(key) => props.onCheck(key)} onHandle={onHandle}>
      <TableCell>
        <h4 class="m-0 text-bold text-lg mb-0">
          <a class="kq_search" href="#">{row.patient}</a>
        </h4>
        Date: <Badge variant="success">{row.date}</Badge>
      </TableCell>
      <TableCell>
        Doctor: <Badge variant="success">{row.doctor}</Badge> <br/>
        Room: <Badge variant="success">{row.room}</Badge> <br/>
        Slot: <Badge variant="success">{row.slot}</Badge>
      </TableCell>
      <TableCell>
        <div class="single-stat-box pull-left">
          <Badge variant={row.status ? 'success' : 'warning'}>{row.status}</Badge>
          <br />
          <span class="text-muted-foreground">Status</span>
        </div>
      </TableCell>
      <TableCell class="text-right">
        <div class="flex gap-2 items-center">
          <AppointmentActionDropdown onAction={props.onAction} key={row.key} status={row.status} doctorId={row.doctorId} />
        </div>
      </TableCell>
    </ListRow>
  );
}
